import React, { useState, useEffect, useContext } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { saveapprove } from "./../../services/wms";
import Input from "./../management/input";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import moment from "moment";
import { toast } from "react-toastify";
import BranchContext from "./../context/branch";
const schema = yup.object({});

const Modalapprove = ({
  isOpen,
  onCancel,
  onconfirm,
  onstatus,
  list,
  onTest,
}) => {
  const { currentBranch } = useContext(BranchContext);

  const [comment, setcomment] = useState("");
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
    control,
  } = useForm({ resolver: yupResolver(schema) });
  const [data, setdata] = useState([]);
  const doSubmit = async (id) => {
    handleSubmit(
      async (data, e) => {
        try {
          const doc = {
            itemcode: list[0].Itemcode,
            branchid: currentBranch._id,
            statusid: id,
            comment: data.remark,
          };
          const { data: result } = await saveapprove(doc);
          if (result.status === "success") {
            toast.success("บันทึกเสร็จเรียบร้อย");
            onconfirm();
          }
        } catch (err) {
          if (err.response && err.response.status === 400) {
            toast.error(err.response.data);
          }
        }
      },

      (error) => {
        // toast.error(err.response.data);
      }
    )();
  };
  const onhandleConfirm = (event) => {
    //   handleonClickonConfirm();
  };
  const onSubmit = () => {
    onconfirm();
  };
  const handleClick = (e) => {
    // setdata(e);
    onSubmit(e);
  };
  const handleCancle = (e) => {
    onCancel();
  };
  const handelonchang = ({ currentTarget: input }) => {
    setcomment(input.value);
  };
  return (
    <>
      <Modal
        className="modal-dialog modal-xl "
        isOpen={isOpen}
        toggle={onCancel}
        centered
      >
        {list &&
          list.length > 0 &&
          list.map((item, index) => (
            <div className="modal-content  " key={index}>
              <div className="modal-header ">
                <span className="d-none d-md-inline text-black pr-2">
                  <span className=" badge rounded-pill bg-primary fs-5">
                    {item.name}
                  </span>
                  <span className="ms-2 text-primary">
                    เลขที่ใบงาน : {item.Itemcode}{" "}
                  </span>
                </span>
                {/* <h5 className="modal-title text-primary ">
                  {item.Data[0].BranchName}
                </h5> */}
              </div>
              <div className="modal-body">
                <div className="row" style={{ fontSize: 14 }}>
                  <div className=" col-lg-4">
                    <div>
                      <h6>
                        สาขาตาชั่ง :
                        <small style={{ fontSize: 14 }}>
                          {item.BranchName}
                        </small>{" "}
                      </h6>
                    </div>
                    <div>
                      <h6>
                        ประเภทลูกค้า :
                        <small style={{ fontSize: 14 }}>
                          {item.CustomerTypeName}
                        </small>
                      </h6>
                    </div>
                    <div>
                      <h6>
                        ชื่อลูกค้า :
                        <small style={{ fontSize: 14 }}>
                          {item.CustomerName}
                          {/* {moment(item.Daterecord, "YYYY-MM-DD").format("YYYY-MM-DD")} */}
                        </small>
                      </h6>
                    </div>
                    <div>
                      <h6>
                        ทะเบียนรถ :
                        <small style={{ fontSize: 14 }}>
                          {item.First_Driven_No}
                          {/* {moment(item.Daterecord, "YYYY-MM-DD").format("YYYY-MM-DD")} */}
                        </small>
                      </h6>
                    </div>
                    <div>
                      <h6>
                        ทะเบียนหาง :
                        <small style={{ fontSize: 14 }}>
                          {item.Second_driven_no}
                          {/* {moment(item.Daterecord, "YYYY-MM-DD").format("YYYY-MM-DD")} */}
                        </small>
                      </h6>
                    </div>
                    <div />
                  </div>

                  <div className=" col-lg-4">
                    <div>
                      <h6>
                        ประเภทสินค้า :
                        <small style={{ fontSize: 14 }}>{item.Type_name}</small>
                      </h6>
                    </div>
                    <div>
                      <h6>
                        ชื่อสิ้นค้า :
                        <small style={{ fontSize: 14 }}>
                          {item.Product_name}
                        </small>
                      </h6>
                    </div>
                    <div>
                      <h6>
                        วัตถุประสงค์ :
                        <small style={{ fontSize: 14 }}>{item.AIM_name}</small>
                      </h6>
                    </div>
                    <div>
                      <h6>
                        สถานที่จัดเก็บ :
                        <small style={{ fontSize: 14 }}>
                          {item.Store_name}
                        </small>
                      </h6>
                    </div>
                    <div>
                      <h6>
                        DO :
                        <small style={{ fontSize: 14 }}>
                          {item.Delivery_No}
                        </small>
                      </h6>
                    </div>
                    <div />
                  </div>

                  <div className=" col-lg-4">
                    <div>
                      <h6>
                        น้ำหนักชั่งเข้า :
                        <small style={{ fontSize: 14 }}>
                          {item.Receive_weightin}
                        </small>
                      </h6>
                    </div>
                    <div>
                      <h6>
                        น้ำหนักชั่งออก :
                        <small style={{ fontSize: 14 }}>
                          {item.Receive_weightout}
                        </small>
                      </h6>
                    </div>
                    <div>
                      <h6>
                        น้ำหนักสุทธิ :
                        <small style={{ fontSize: 14 }}>
                          {item.Receive_weightnet}
                        </small>
                      </h6>
                    </div>
                    <div>
                      <h6>
                        ผู้แจ้ง :
                        <small style={{ fontSize: 14 }}>
                          {item.userrecord}
                        </small>
                      </h6>
                    </div>
                    <div>
                      <h6>
                        ผู้อนุมัติ :
                        <small style={{ fontSize: 14 }}>
                          {item.User_Approve}
                        </small>
                      </h6>
                    </div>
                    <div />
                  </div>
                </div>
              </div>

              <div className="row">
                <span className="ms-3 fs-4 fw-bold text-primary mb-2">
                  รายการที่ขอแก้ไขข้อมูล
                </span>
                {list &&
                  list.length > 0 &&
                  list[0].Data.length > 0 &&
                  list[0].Data.map((item, index) => {
                    return (
                      <div className="container-fluid" key={index}>
                        <div>
                          <div className="row m-1">
                            <div className="col-lg-4">
                              <div style={{ fontSize: "14px" }}>
                                <span className="badge rounded-pill bg-secondary">
                                  {index + 1}
                                </span>{" "}
                                <span
                                  className="badge  text-primary"
                                  style={{ fontSize: "14px" }}
                                >
                                  {item.Detailname}
                                </span>
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div style={{ fontSize: "14px" }}>
                                <h6>
                                  ข้อมูลเก่า :
                                  <span
                                    className="badge rounded text-dark ms-2"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {item.olddata}
                                  </span>
                                </h6>
                              </div>
                            </div>

                            <div className="col-lg-4">
                              <div>
                                ข้อมูลใหม่ :
                                <span
                                  className="badge rounded text-dark ms-2  "
                                  style={{ fontSize: "14px" }}
                                >
                                  {item.newdata}
                                </span>
                              </div>
                            </div>

                            {item.UpdateHub === "" && (
                              <span
                                className="col-auto badge rounded bg-warning text-dark ms-2 "
                                style={{ fontSize: 14 }}
                              >
                                รอแก้ไข
                              </span>
                            )}
                            {item.UpdateHub !== "" && (
                              <span
                                className="col-auto badge rounded bg-success  ms-2 "
                                style={{ fontSize: 14 }}
                              >
                                แก้ไขเรียบร้อย
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
              <hr />

              <div className="row mx-2">
                <span
                  className="col-auto badge rounded bg-warning text-dark ms-2"
                  style={{ fontSize: 16 }}
                >
                  เหตุผล : {item.comment}
                </span>
                {/* <Input
                  icon="bi bi-book-half text-primary me-2"
                  label="หมายเหตุ"
                  name="remark"
                  // value={comment}
                  // onChange={handelonchang}
                  register={register}
                  required
                  errors={errors.codepp}
                /> */}
              </div>
              <div className="d-flex justify-content-end my-3 me-3">
                {list.length > 0 && list[0].statusid == "2" && (
                  <>
                    <button
                      type="button"
                      className="btn btn-primary  me-2"
                      onClick={handleSubmit(() => doSubmit(3))}

                      // onClick={() => handleClick([item.Customer_code, "3"])}
                      // onClick={handleSubmit(onSubmit)}
                    >
                      <i className="bi bi-check-circle-fill me-2" />
                      อนุมัติ
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger me-2"
                      onClick={handleSubmit(() => doSubmit(4))}
                      // onClick={() => handleClick([item.Customer_code, "4"])}
                    >
                      <i className="bi bi-x-circle-fill " />
                      ไม่อนุมัติ
                    </button>
                  </>
                )}

                {/* {list.length > 0 && list[0].Data[0].status == "อนุมัติ" && (
                  <></>
                )} */}

                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCancle}
                >
                  <i className="bi bi-x-circle me-2" />
                  ยกเลิก
                </button>
              </div>
            </div>
          ))}
      </Modal>
    </>
  );
};

export default Modalapprove;
